import { dataYaoSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconYaoSquare = /*#__PURE__*/createIcon(dataYaoSquare)
export default IconYaoSquare
